import { render, staticRenderFns } from "./PorcentajeAvance.vue?vue&type=template&id=58cbdd40&scoped=true&"
import script from "./PorcentajeAvance.vue?vue&type=script&lang=js&"
export * from "./PorcentajeAvance.vue?vue&type=script&lang=js&"
import style0 from "./PorcentajeAvance.vue?vue&type=style&index=0&id=58cbdd40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cbdd40",
  null
  
)

export default component.exports